import React from 'react';
import { shape, number, oneOf, bool } from 'prop-types';
import { getMonthNameByMonthNumber, progressUnionTypes } from '@paddl/utils-js';
const getFormattedDate = _ref => {
  let {
    month,
    year
  } = _ref;
  return "".concat(getMonthNameByMonthNumber(month), " ").concat(year);
};
const getFormattedEndDate = _ref2 => {
  let {
    endMonth,
    endYear
  } = _ref2;
  const isEndDateFulfilled = endMonth !== null && endYear !== null;
  const currentDate = new Date();
  return isEndDateFulfilled ? getFormattedDate({
    month: endMonth,
    year: endYear
  }) : getFormattedDate({
    month: currentDate.getMonth() + 1,
    year: currentDate.getFullYear()
  });
};
const getFormattedEndDateForProgressType = _ref3 => {
  let {
    endMonth,
    endYear,
    progressType,
    isCurrent
  } = _ref3;
  switch (progressType) {
    case 'INDEFINITE':
      if (isCurrent) {
        return 'current';
      }
      return getFormattedEndDate({
        endMonth,
        endYear
      });
    case 'TIME_BOX':
    default:
      return getFormattedEndDate({
        endMonth,
        endYear
      });
  }
};
export const getDuration = _ref4 => {
  let {
    startDate,
    endDate = {
      day: null,
      month: null,
      year: null
    },
    timeStamp,
    progressType,
    isCurrent
  } = _ref4;
  return progressType !== 'TIME_STAMP' ? [getFormattedDate(startDate), '-', getFormattedEndDateForProgressType({
    endMonth: endDate.month,
    endYear: endDate.year,
    progressType,
    isCurrent
  })].join(' ') : [getFormattedDate(timeStamp || startDate)];
};
export const Duration = _ref5 => {
  let {
    progressType,
    isCurrent,
    startDate,
    endDate,
    timeStamp
  } = _ref5;
  return /*#__PURE__*/React.createElement("div", {
    className: "duration",
    "data-test-id": "duration-text"
  }, getDuration({
    startDate,
    endDate,
    timeStamp,
    progressType,
    isCurrent
  }));
};
Duration.propTypes = {
  progressType: oneOf(progressUnionTypes).isRequired,
  isCurrent: bool.isRequired,
  startDate: shape({
    month: number,
    year: number
  }),
  endDate: shape({
    month: number,
    year: number
  }),
  timeStamp: shape({
    month: number,
    year: number
  })
};
Duration.defaultProps = {
  startDate: null,
  endDate: null,
  timeStamp: null
};